import { z } from 'zod'
import { useZorm } from 'react-zorm'
import {
    FormField,
    fieldDescription,
    withProps,
} from '@codecorp/zorm-conventions'
import { ShowBarcode } from '../components/show-barcode'
import { CreatorButtons } from '../components/creator-buttons'
import { wifi } from '@codecorp/barcode-data-generator'
import { useFormReset } from '../hooks/use-form'
import { useShowModal } from '../hooks/use-show-modal'

const FormSchema = z.object({
    label: z.string().describe(
        fieldDescription({
            placeHolder: 'This name will be placed under the QR Code.',
        })
    ),
    ssid: z
        .string()
        .min(1)
        .describe(
            fieldDescription({
                label: 'Network Name',
                placeHolder: 'Enter the SSID',
            })
        ),
    password: z
        .string()
        .optional()
        .describe(
            fieldDescription({ placeHolder: 'Enter your password here' })
        ),
    encryption: z.enum(['WPA', 'WEP', 'nopass']).describe(fieldDescription({})),
})

export const WifiBarcodeCreator = () => {
    const { setSubmittedBarcode, handleFormReset } = useFormReset(undefined)
    const showModal = useShowModal()

    const zo = useZorm('wifiBarcode', FormSchema, {
        onValidSubmit: async ({ preventDefault, data }) => {
            preventDefault()

            setSubmittedBarcode(data)
            showModal(
                <ShowBarcode
                    label={data.label}
                    barcode={wifi({
                        ssid: data.ssid,
                        password: data.password,
                        encryption: data.encryption,
                    })}
                />
            )
        },
    })

    return (
        <div>
            <form
                ref={zo.ref}
                className="ml-10 mr-10 leading-10"
                onReset={handleFormReset}
            >
                {zo.fields.label(FormField)}
                {zo.fields.ssid(FormField)}
                {zo.fields.password(FormField)}
                {zo.fields.encryption(
                    withProps({ defaultValue: 'WPA' }, FormField)
                )}
                <CreatorButtons />
            </form>
        </div>
    )
}
